import { gql } from '@apollo/client';

export const DELETE_AUDIT_DECISION = gql`
  mutation DeleteAuditDecision($input: DeleteAuditDecisionInput!) {
    deleteAuditDecision(input: $input) {
      auditItem {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        auditSessionId
        status
        position
        contentSnapshot {
          audioFileUrl
          transcription
          language
          topic
          contentType
          classificationType
          classificationResults {
            name
            severity
          }
          metadata
          triggeredPolicies {
            id
            name
            description
            isEnabled
            labels {
              labelId
              severity
            }
          }
          nonTriggeredPolicies {
            id
            name
            description
            isEnabled
            labels {
              labelId
              severity
            }
          }
          slmModelVersion
          slmPromptVersion
          quicktxtModelVersion
        }
        kustoReference {
          communityId
          subjectId
          timestamp
        }
        decisions {
          id
          auditItemId
          auditSessionId
          auditorId
          auditorName
          timestamp
          updatedAt
          isSelected
          selectedBy
          selectedAt
          languageCorrect
          transcriptionCorrect
          correctedTranscription
          originalLabels {
            name
            severity
          }
          correctedLabels {
            name
            severity
          }
          comments
        }
        decisionsCount
        selectedDecisionId
      }
    }
  }
`;
